__webpack_require__.p = "https://www.utpl.edu.ec/olimpiadas2026/";